import { useRef, useEffect } from 'react';
import {
  RecievedMessage, SentMessage, Row, Chats } from "./style";
import MessageDate from './date'
import NewVoiceMessage from './newVoiceMessage'
import Message from './message'
import CircularProgress from '@mui/material/CircularProgress'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import IconButton from '@mui/material/IconButton';
import axios from '../../../functions/requestInterceptor'
import {useParams} from "react-router-dom";
import help from '../../../files/help.m4a'
import { toast } from 'react-toastify';

export default function MessageListBox(props) {
  const { messageList, loading, uploadStatus, audio, imageFile } = props
  const urlParams = useParams()

  const selfUser = JSON.parse(localStorage.getItem('user'))

  const chatContainer = useRef(null);

  const resendVoice = () => {
    props.handleUploadVoice()
  }

  const deleteVoiceMessage = (messageId) => {
    axios.delete(`/tickets/${urlParams.ticketId}/messages/${messageId}`)
     .then(() => {
        props.reloadMessages()
        toast.success("پیام شما با موفقیت حذف شد.", {
          position: "top-right"
        });
     })
     .catch((error) => {
        toast.error(error?.response?.data?.detail, {
          position: "top-right"
        });
     });
  }

  const setScrollToBottom = () => {
    chatContainer.current.scrollTop = chatContainer.current.scrollHeight;
  } 

  useEffect(() => {
    if (chatContainer.current) {
      setScrollToBottom()
    }
  }, [messageList])

  if (loading) return null

  return (
   <div style={{overflowY: 'scroll'}} ref={chatContainer}>
     <Chats>
      {props.category.id === 1 &&
        <Row>
          <RecievedMessage voiceType>
            <audio
              src={help}
              controls />
          </RecievedMessage>
        </Row>
      }
      {props.category.id === 7 &&
        <Row>
          راهنما
          <RecievedMessage voiceType>
            <audio
              src={help}
              controls />
          </RecievedMessage>
        </Row>
      }
      {messageList.map((msg) => {
        if (msg.sender.id === selfUser.id) {
          return (
            <SentMessage key={msg.date} voiceType={!!msg.file}>
              <Message message={msg} />
              <span>
                <MessageDate date={msg.date} className='sent' />
                 <IconButton size="small" onClick={() => deleteVoiceMessage(msg.id)}>
                  <DeleteForeverIcon fontSize="small" color={'#d60606'} />
                 </IconButton>
              </span>
            </SentMessage>
          )
        } else {
          return (
            <Row key={msg.date}>
              <RecievedMessage voiceType={!!msg.file}>
                <Message message={msg} />
                <MessageDate date={msg.date} className='recieved' />
              </RecievedMessage>
            </Row>
          )
        }
      })}
     {audio &&
      <NewVoiceMessage
       audio={audio}
       uploadStatus={uploadStatus}
       resendVoice={resendVoice}
      />
     }
       {imageFile &&
        <SentMessage voiceType={false}>
          <span style={{display: 'flex', justifyContent: 'center', alignItems: "center"}}>
            <CircularProgress size={15} style={{ position: 'absolute' }} />
          </span>
        </SentMessage>
       }
    </Chats>
   </div>
  );
}
